module.exports = __webpack_public_path__ + "static/media/sb_logo.c2ed6ba4.png";